<template>
  <div class="tile" :class="tone ? 'tile--' + tone : ''">
    <span class="tile__label">{{ label }}</span>
    <span class="tile__value">{{ value }}</span>
    <span v-if="meta" class="tile__meta">{{ meta }}</span>
  </div>
</template>

<script>
export default {
  name: "StatTile",
  props: {
    label: { type: String, default: "" },
    value: { type: [String, Number], default: "" },
    meta: { type: String, default: "" },
    // danger / warn / accent — reserved for state, never decoration
    tone: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
.tile {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.tile--danger {
  background: var(--danger-tint);
  border-color: var(--danger-line);

  .tile__label,
  .tile__meta {
    color: var(--danger);
  }
  .tile__value {
    color: var(--danger);
  }
}

.tile--warn {
  background: var(--warn-tint);
  border-color: #ecdcae;

  .tile__label,
  .tile__meta,
  .tile__value {
    color: var(--warn);
  }
}

.tile--accent {
  background: var(--brand-tint);
  border-color: var(--brand-line);

  .tile__label,
  .tile__meta {
    color: #1e4c9a;
  }
  .tile__value {
    color: var(--brand-ink);
  }
}

.tile__label {
  font-size: var(--fs-xs);
  color: var(--ink-4);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tile__value {
  font-size: 24px;
  font-weight: 700;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
  line-height: 1.15;
}

.tile__meta {
  font-size: var(--fs-xs);
  color: var(--ink-3);
}
</style>
